import '@stream-io/video-react-sdk/dist/css/styles.css';
import './custom-styles.css';
import { ToggleAudioPublishingButton } from '../call-controls/toggle-audio-publishing-button';
import { ToggleVideoPublishingButton } from '../call-controls/toggle-video-publishing-button';
import { ScreenShareButton } from '../call-controls/screen-share-button';
import { BackgroundFilterSettings } from '../call-controls/background-filter-settings';
import { EndCallButton } from '../call-controls/end-call-button';
import { useIsMobile } from '@/hooks/useIsMobile';

export const CallControls = () => {
  const isMobile = useIsMobile();

  return (
    <div className="mt-4 w-full flex items-center justify-center space-x-2">
      <ToggleAudioPublishingButton />
      <ToggleVideoPublishingButton />
      <ScreenShareButton />
      {!isMobile && <BackgroundFilterSettings />}
      <EndCallButton />
    </div>
  );
};
